export const SAVE_PARTNER = 'SAVE_PARTNER';
export const UPDATE_PARTNER = 'UPDATE_PARTNER';
export const GET_PARTNER = 'GET_PARTNER';
